/* eslint-disable react/no-array-index-key */
import { VpSkeleton } from '@vtmn-play/react'
import { useProductsContext } from '@/contexts/products/useProductsContext'

export function ProductsSkeleton({ rowCount = 1 }: Readonly<{ rowCount?: number }>) {
  const { columns } = useProductsContext()

  return (
    <>
      {Array.from({ length: columns * rowCount }).map((_, i) => (
        <div className="product-card-container" key={i}>
          <VpSkeleton
            data-testid="product-card-skeleton"
            key={i}
            shape="squared"
            style={{ width: '100%', height: '300px' }}
          />
        </div>
      ))}
    </>
  )
}
